import React from 'react';
import './SkillCard.css';

// Reuses the existing 6-state topic-intelligence vocabulary VERBATIM — never
// reinterprets mastered/strong/improving/needs_attention/declining/
// insufficient_data. `masteryPct` drives the bar fill; states without a
// meaningful accuracy number (insufficient_data) show an honest "not enough
// evidence yet" bar instead of a fabricated percentage.
const STATE_LABEL = {
  mastered: 'Mastered',
  strong: 'Strong',
  improving: 'Improving',
  needs_attention: 'Needs attention',
  declining: 'Declining',
  insufficient_data: 'Not enough evidence yet',
};

const SkillCard = ({ topicName, state, masteryPct, onClick }) => {
  const hasEvidence = state !== 'insufficient_data' && typeof masteryPct === 'number';
  const Tag = onClick ? 'button' : 'div';

  return (
    <Tag className={`z-skill-card z-skill-card--${state}`} onClick={onClick} type={onClick ? 'button' : undefined}>
      <div className="z-skill-card-top">
        <span className="z-skill-card-name">{topicName}</span>
        <span className="z-skill-card-state">{STATE_LABEL[state] || state}</span>
      </div>
      <div className="z-skill-card-track">
        <div
          className="z-skill-card-fill"
          style={{ width: hasEvidence ? `${Math.round(masteryPct)}%` : '8%' }}
        />
      </div>
      {hasEvidence && <span className="z-skill-card-pct">{Math.round(masteryPct)}%</span>}
    </Tag>
  );
};

export default SkillCard;
